module.exports = __webpack_public_path__ + "img/261-3.8711272a.png";